import React, { useState, useEffect, useMemo } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState(""); // Track the current sorted field
  const [sortOrder, setSortOrder] = useState(""); // Track the current sort order
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      console.log("fetchData", filters, sortField, sortOrder);
      const token = localStorage.getItem("token");
      console.log("filters", filters);

      // Prepare query parameters

      // Dynamically construct query parameters, excluding empty sortField and sortOrder
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters, // Spread the filters object into the query params
      };

      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));

      // Create the query string
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch suppliers and materials concurrently
      const { data: categories, pagination } = await fetchDataFromAPI(
        `/api/categories`,
        filterParams,
        token
      );

      // Update state
      setCategories(categories || []);
      setTotalPages(pagination?.totalPages || 1);

      console.log("categories:", categories);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };
  const handleAddRow = async () => {
    try {
      // Find max index from existing categories
      const maxIndex = categories.reduce((max, row) => {
        const match = row.name?.match(/New category (\d+)/);
        if (match) {
          const idx = parseInt(match[1], 10);
          return idx > max ? idx : max;
        }
        return max;
      }, 0);

      const newIndex = maxIndex + 1;

      const newRow = {
        name: `New category ${newIndex}`,
        type: null,
        description: null,
        parent_id: null,
        status: "active",
      };

      console.log("category newRow", newRow);

      if (isOffline) {
        storeOfflineData([newRow], "categories", "add");
        setCategories((prev) => [...prev, newRow]);
      } else {
        const response = await saveData("/api/categories", newRow, "POST");
        setCategories((prev) => [...prev, { id: response.id, ...newRow }]);
      }
    } catch (err) {
      console.error("Error adding row:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      if (isOffline) {
        storeOfflineData([updatedData], "categories", "update"); // Store the updated data offline
      } else {
        await saveData(`/api/categories/${id}`, updatedData);
      }
      fetchData();
    } catch (err) {
      console.error("Error editing categories:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      if (isOffline) {
        storeOfflineData([{ id }], "categories", "delete"); // Store the deletion offline
      } else {
        await deleteData(`/api/categories/${id}`);
      }
      fetchData();
    } catch (err) {
      console.error("Error deleting categories:", err);
    }
  };
  const handlePageChange = (newPage) => {
    console.log("Parent - Page changed to:", newPage); // Log in parent
    setCurrentPage(newPage); // Update the current page
    fetchData(newPage, 10); // Fetch new data
  };
  const handleSort = (field, order) => {
    console.log("handleSort,field,order", field, order);
    setSortField(field); // Update the sorted field
    setSortOrder(order); // Update the sort order (asc/desc)
  };
  const handleFilterChange = (newFilters) => {
    console.log("handleFilterChange", newFilters);
    setFilters(newFilters); // Update filters in the parent state
    fetchData(currentPage, newFilters); // Refetch data with new filters
  };
  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Type ", accessor: "type" },
    { header: "Description", accessor: "description" },

    {
      header: "Status",
      accessor: "status",
      type: "dropdown", // Specify the column type
      options: [
        { value: "active", label: "Active" },

        { value: "inactive", label: "Inactive" },
      ],
    },
  ];

  console.log("columns", columns);
  return (
    <DataTable
      title="Categories"
      columns={columns}
      data={categories}
      currentPage={currentPage}
      setData={setCategories}
      totalPages={totalPages}
      onSort={handleSort}
      sortOrder={sortOrder}
      sortField={sortField}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/categories"
      itemsPerPage={10}
      fetchData={fetchData}
    />
  );
};

export default Categories;
